import { computed, get } from '@ember/object';
export default function uniqBy(key, property) {
  return computed(key, function () {
    const uniqueArray = [];
    const propertyValuesSeen = new Set();
    const array = this.get(key);
    if (array) {
      for (const item of array) {
        const propertyVal = get(item, property);
        if (!propertyValuesSeen.has(propertyVal)) {
          propertyValuesSeen.add(propertyVal);
          uniqueArray.push(item);
        }
      }
    }
    return uniqueArray;
  });
}